import MypageCancelContainer from './MypageCancelContainer';
export default MypageCancelContainer;
